const p = {
  50: "0px 1px 0px 0px rgba(49, 67, 81, 0.2)",
  100: "0px 4px 4px 0px rgba(0, 0, 0, 0.01), 0px 3px 3px 0px rgba(0, 0, 0, 0.02), 0px 2px 2px 0px rgba(0, 0, 0, 0.04), 0px 1px 0px 0px rgba(0, 0, 0, 0.09), 0px 0px 0px 1px rgba(6, 20, 34, 0.1)",
  200: "0px 4px 8px 0px rgba(0, 0, 0, 0.02),0px 3px 6px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.08),0px 1px 0px 0px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgba(6, 20, 34, 0.1)",
  400: "0px 0px 0px 1px rgba(49, 67, 81, 0.06), 0px 4px 12px 0px rgba(0, 0, 0, 0.08), 0px 4px 32px 0px rgba(0, 0, 0, 0.06)",
  500: "0px 0.35px 2.51px 0px rgba(0, 0, 0, 0.0194), 0px 1.58px 5.79px 0px rgba(0, 0, 0, 0.0307), 0px 3.93px 13.22px 0px rgba(0, 0, 0, 0.0393), 0px 7.65px 28.17px 0px rgba(0, 0, 0, 0.0506), 0px 13px 54px 0px rgba(0, 0, 0, 0.07), 0px 0px 0px 1px rgba(49, 67, 81, 0.2)",
  700: "0px 10px 40px 0px rgba(64, 82, 97, 0.3), 0px 2px 3px 0px rgba(64, 82, 97, 0.2)",
  inverted: {
    50: "0px -1px 0px 0px rgba(49, 67, 81, 0.2)"
  }
};
export {
  p as shadow
};
